import * as Dialog from '@radix-ui/react-dialog';
import clx from 'classnames';
import { easeOut, motion } from 'motion/react';
import { ModalProps } from '../views/types';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import { OVERLAY_CLASSNAME } from './const';

const ModalClassicLayout = ({
  children,
  closeModal,
  title,
  onSubmit,
  alert = false,
  submitLabel,
  subTitle,
  isLoadingContent,
  isSubmitDisabled,
  isLoading,
}: ModalProps) => (
  <Dialog.Root onOpenChange={closeModal} defaultOpen open>
    <Dialog.Portal>
      <motion.div
        key={`modal-overlay-${title}`}
        animate={{
          backgroundColor: '#FBF7EB70',
          backdropFilter: 'blur(10px) opacity(1)',
          transition: { duration: 0.2, ease: easeOut },
        }}
        className={clx(
          OVERLAY_CLASSNAME,
          'fixed inset-0 flex items-end md:items-center bg-neutral-50 backdrop-blur-sm',
        )}
        exit={{
          backgroundColor: '#D4AF3700',
          backdropFilter: 'blur(10px) opacity(0)',
          opacity: 0,
          transition: { duration: 0.2, ease: easeOut },
        }}
        initial={{ backgroundColor: '#D4AF3700', backdropFilter: 'blur(10px) opacity(0)' }}
      >
        <Dialog.Overlay className="fixed inset-0" />
        <motion.div
          animate={{
            y: 0,
            transition: { duration: 0.2, ease: easeOut },
          }}
          className="w-full md:max-w-vw-2/3 xl:max-w-screen-lg md:mx-auto relative z-10"
          exit={{
            y: '-0.75rem',
            transition: { duration: 0.2, ease: easeOut },
          }}
          initial={{ y: '-0.75rem' }}
          onClick={(e) => e.stopPropagation()}
        >
          <Dialog.Content className="w-full">
            <div className="bg-neutral-50 h-fit max-h-[85vh] md:max-h-[80vh] flex flex-col rounded-sm p-2 border-4 border-neutral-100">
              <ModalHeader
                closeModal={closeModal}
                isLoadingContent={isLoadingContent}
                subTitle={subTitle}
                title={title}
              />
              <fieldset className="contents" disabled={isLoading || isLoadingContent}>
                <div className="px-6 py-4 overflow-y-auto grow">{children}</div>
                {(onSubmit || alert) && (
                  <ModalFooter
                    alert={alert}
                    isLoading={isLoading}
                    isLoadingContent={isLoadingContent}
                    isSubmitDisabled={isSubmitDisabled}
                    onSubmit={onSubmit}
                    submitLabel={submitLabel}
                  />
                )}
              </fieldset>
            </div>
          </Dialog.Content>
        </motion.div>
      </motion.div>
    </Dialog.Portal>
  </Dialog.Root>
);

export default ModalClassicLayout;
